import { useEffect, useState } from 'react';

import { useAutoPollingMatchItem } from 'store/modules/api/hooks/useAutoPollingMatchItem';
import { normaliseMatch } from './normaliseMatch';

/**
 * Live-polling gate + matchInfo/liveMatch normalisation.
 *
 * @param {object} matchInfo - The match object as supplied by the fixture list API.
 * @returns {object} { match, genericStatus, matchId }
 */
export function useMatchCardData(matchInfo) {
    const [fetchLiveMatch, setFetchLiveMatch] = useState(false);
    const { data: liveMatch } = useAutoPollingMatchItem(matchInfo.providerId, {
        skip: !fetchLiveMatch
    });

    useEffect(() => {
        const matchInfoStatus = PULSE.app.common.match.getMatchStatus(
            matchInfo.status
        );

        if (
            matchInfoStatus === PULSE.app.common.CONSTANTS.MATCH_STATUS.LIVE ||
            PULSE.app.common.match.startsWithinAnHour(
                matchInfoStatus,
                matchInfo.utcStartTime
            ) ||
            (PULSE.app.common.match.isPastStartTime(matchInfo.utcStartTime) &&
                matchInfoStatus !==
                    PULSE.app.common.CONSTANTS.MATCH_STATUS.COMPLETED)
        ) {
            setFetchLiveMatch(true);
        }
    }, [matchInfo.status, matchInfo.utcStartTime]);

    const match = normaliseMatch(matchInfo, liveMatch);

    const genericStatus = PULSE.app.common.match.getMatchStatus(match.status);

    return {
        match,
        genericStatus,
        matchId: matchInfo.providerId
    };
}
